import { Button } from 'components/button/Button';
import styled, { css } from 'styled-components';
import { primaryBoxShadow } from 'styles/theme';
import { KCFColor } from 'styles/themes/KCFColor';
import { hexToRGBA } from 'utils/color';

export const defaultButtonStyle = css`
    font-size: 1.4rem;
    min-width: 100px;
    padding: 14px 20px;
    background: ${KCFColor.defaultButton};
    color: ${KCFColor.defaultButtonTextColor};
    box-shadow: ${primaryBoxShadow};

    &:hover {
        background: ${KCFColor.defaultButtonHover};
    }

    &:disabled {
        color: ${KCFColor.white};
        background: ${hexToRGBA(KCFColor.defaultButton, 0.25)};
        box-shadow: none;
    }
`;

export const DefaultButton = styled(Button)`
    ${defaultButtonStyle}
`;
